import React from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { disableBusinessFilter, enableBusinessFilter } from '../../actions/business_filter'

const BusinessFilter = (props) => {
  const defaultFilter = 'Business: All'

  const handleSelectFilter = (e) => {
    const business = e.target.value === defaultFilter ? null : e.target.value
    props.updateFilter({ business })
  }

  const { isFetching } = props
  const businesses = props.businesses
    ? props.businesses
        .filter((b) => b.name !== 'Business Name' || b.name !== 'business_template')
        .sort((a, b) =>
          a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0
        )
    : null
  return (
    <>
      <div className='input-group'>
        <select
          id='business'
          value={props.filter ? props.filter : defaultFilter}
          name='business'
          className='form-control'
          onChange={handleSelectFilter}
          disabled={isFetching}
        >
          <option key={props.filter || defaultFilter} defaultValue={defaultFilter}>
            {defaultFilter}
          </option>
          {businesses &&
            businesses.map((business) => (
              <option key={business.id} value={business.id}>
                {business.name}
              </option>
            ))}
        </select>
        {isFetching && (
          <span
            className='input-group-addon'
            style={{ alignItems: 'center', display: 'flex', backgroundColor: '#e9ecef' }}
          >
            <i className='fa fa-refresh fa-spin' />
          </span>
        )}
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  businesses: state.businessesAll.businesses,
  isFetching: state.businessesAll.isFetching,
  searchTerm: state.transactionSearch.searchTerm,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      enableBusinessFilter,
      disableBusinessFilter,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessFilter))
